<div class="image-carousel">
  @if (Images.length == 0) {
    <div class="carousel-image">
      <i> No images </i>
    </div>
  }
  @if (Images.length > 0) {
    <div>
      <div class="carousel-wrapper">
        <div class="carousel-images" [ngStyle]="{'transform': 'translateX(' + (165 + -currentIndex * 33) + '%)'}">
          @for (image of Images; track image; let i = $index) {
            <div [style.opacity]="getOpacity(i)" [class.active]="i === currentIndex" (click)="show(i)">
              <img [src]="image" alt="Image">
              @if (ImageCaptions.length == Images.length) {
                <span>
                  {{ImageCaptions[i]}}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  <div class="dots">
    @for (image of Images; track image; let i = $index) {
      <span class="dot" [class.active]="i === currentIndex" (click)="show(i)"></span>
    }
  </div>
</div>
